import React, { useState } from 'react';
import { Text } from '@design-system/Text';
import { ModalContainer } from '../style';
import { useFormik } from 'formik';
import { InputLabel } from '@design-system/InputLabel';
import { TextInput } from '@design-system/TextInput';
import * as Yup from 'yup';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { getLoading } from '@app/auth/redux/selectors';
import { sign_up } from '@app/auth/redux/reducer';
import { Button } from '@design-system/Button';

const Signup = () => {
  const [show, setShow] = useState(false);
  const loading = useSelector(getLoading);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      phone: '',
    },
    onSubmit: async (payload) => {
      dispatch(sign_up(payload));
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required('First name is required.'),
      last_name: Yup.string().required('Last name is required.'),
      email: Yup.string()
        .required('Email is required.')
        .email('Invalid email address'),
      phone: Yup.string()
        .required('Phone number is required')
        .matches(/^[0-9]+$/, 'Phone number must be 10 digits.')
        .min(10)
        .max(14),
      password: Yup.string()
        .matches(/[a-z0-9]/, 'Password must include letters and numbers')
        .required('Password is required.')
        .min(8, 'Password is too short - should be at least 8 characters.'),
    }),
  });
  return (
    <ModalContainer>
      <div className="form_body">
        <form onSubmit={formik.handleSubmit}>
          <div className="form_content">
            <InputLabel htmlFor="firstname">First Name</InputLabel>
            <TextInput
              name="first_name"
              type="text"
              id="firstname"
              placeholder="First Name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.first_name}
            ></TextInput>
            {formik.touched.first_name && formik.errors.first_name ? (
              <Text color="red" align="left">
                {formik.errors.first_name}
              </Text>
            ) : null}
          </div>

          <div className="form_content">
            <InputLabel htmlFor="lastname">Last Name</InputLabel>
            <TextInput
              name="last_name"
              type="text"
              id="lastname"
              placeholder="Last Name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.last_name}
              error={formik.touched.last_name && formik.errors.last_name}
            ></TextInput>
            {formik.touched.last_name && formik.errors.last_name ? (
              <Text color="red" align="left">
                {formik.errors.last_name}
              </Text>
            ) : null}
          </div>

          <div className="form_content">
            <InputLabel htmlFor="email">Email</InputLabel>
            <TextInput
              name="email"
              type="email"
              id="email"
              placeholder="Email Address"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
            />
            {formik.touched.email && formik.errors.email ? (
              <Text color="red" align="left">
                {formik.errors.email}
              </Text>
            ) : null}
          </div>

          <div className="form_content">
            <InputLabel htmlFor="phone">Phone Number</InputLabel>
            <TextInput
              name="phone"
              type="text"
              id="phone"
              placeholder="Phone Number"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.phone}
            ></TextInput>
            {formik.touched.phone && formik.errors.phone ? (
              <Text color="red" align="left">
                {formik.errors.phone}
              </Text>
            ) : null}
          </div>

          <div className="form_content">
            <InputLabel htmlFor="password">Password</InputLabel>
            <div className="password_box">
              <input
                type={show ? 'text' : 'password'}
                name="password"
                placeholder="Password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
              {show ? (
                <AiOutlineEyeInvisible
                  onClick={() => setShow(!show)}
                  size={20}
                  style={{ marginTop: '7px' }}
                />
              ) : (
                <AiOutlineEye
                  onClick={() => setShow(!show)}
                  size={20}
                  style={{ marginTop: '7px' }}
                />
              )}
            </div>
            {formik.touched.password && formik.errors.password ? (
              <Text color="red" align="left">
                {formik.errors.password}
              </Text>
            ) : null}
          </div>

          <Button
            disabled={loading}
            bgColor="#549A9A"
            weight="500"
            style={{ marginTop: 30, marginBottom: 32 }}
            text={loading ? 'Loading...' : 'Get Started'}
            type="submit"
          />
        </form>
      </div>
    </ModalContainer>
  );
};

export default Signup;
